import { render, staticRenderFns } from "./itStatement.vue?vue&type=template&id=ed15c8e6&scoped=true"
import script from "./itStatement.vue?vue&type=script&lang=js"
export * from "./itStatement.vue?vue&type=script&lang=js"
import style0 from "./itStatement.vue?vue&type=style&index=0&id=ed15c8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed15c8e6",
  null
  
)

export default component.exports